export default __webpack_public_path__ + "static/media/medaille-bdo-bronze-conception.5ab563b6.png";